export default __webpack_public_path__ + "static/media/profile-img.ed2cb3b1.png";